module.exports = __webpack_public_path__ + "img/icon6.42fdb375.png";